import { render, staticRenderFns } from "./RouteLocationSelector.vue?vue&type=template&id=def84efe&"
import script from "./RouteLocationSelector.vue?vue&type=script&lang=js&"
export * from "./RouteLocationSelector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports